import { Locale } from "../types";

export const getLocale = (): Locale =>
  navigator.language.startsWith("ru") ? "ru" : "en";
